<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>BACS Service User Number (SUN)</h1>
    <p>This is a 6-digit number provided by your bank that identifies your business when we submit your BACS payments.</p>
    </div>
    <div class="cell small=8">
        <form class="fieldset" @submit.prevent> 
          <label class="custom-check">
          <input type="checkbox" v-model="formData.sunLinked">I have linked my BACS Service User Number (SUN) to Qtac Solutions Ltd<span class="checkmark"></span>
        </label> 
        </form>
    </div>

    <div class="cell small-5">
      <form class="fieldset" @submit.prevent> 
        <input 
          type="text" 
          id="submissionUserNumber" 
          name="submissionUserNumber" 
          placeholder="" 
          v-model="formData.submissionUserNumber" 
          maxlength="6"
          required 
        />
      </form>
    </div>
  


</template>


<script setup>

import { ref, onMounted, watch } from 'vue'

const error = ref([]);

const props = defineProps({
  formData: Object
})


const validateStep = () => {

  error.value = [];


  if (!props.formData.sunLinked) {
    error.value.push('You must confirm that you have linked your BACS Service User Number (SUN) to Qtac Solutions Ltd.');
  }

  if (!props.formData.submissionUserNumber) {
    error.value.push('A valid Submission User Number must be provided.');
  } else if (!/^\d+$/.test(props.formData.submissionUserNumber)) {
    error.value.push('A valid Submission User Number must be provided.');
  } else if (props.formData.submissionUserNumber.length > 6) {
    error.value.push('A valid Submission User Number must be provided.');
  }

  if (error.value.length > 0) return false;


  return true;
}

watch(
  () => props.formData.sunLinked,
  (newValue) => {
    if (newValue) {
      props.formData.submissionUserNumber = '';
      document.getElementById('submissionUserNumber').disabled = false;
    } else {
      document.getElementById('submissionUserNumber').disabled = true;
    }
  }
);


const executeStep = async () => {
  return true;
}



onMounted(() => {
  if (props.formData.sunLinked || props.formData.sunLinked === undefined || props.formData.sunLinked === 'false') { 
    document.getElementById('submissionUserNumber').disabled = true;
  }
});

defineExpose({ validateStep, executeStep });

</script>